// fr
export const leaveRequest = {
  title: "Nouvelle demande de congé",
  add_leave: "+ Ajouter un congé",
  save_request: "Enregistrer la demande",
  leave_type: "Type de congé",
  leave_types: {
    CP: "CP",
    RTT: "RTT",
    Maladie: "Maladie",
    NonPaye: "Non payé",
  },
  description: "Description",
  actions: {
    add: "Ajouter",
    cancel: "Annuler",
    edit: "✏️",
    delete: "🗑",
  },
  justification: "Pièce justificative",
  comment: "Commentaire",
  email_sent_success: "✅ Email de demande de congé envoyé avec succès !",
  email_sent_error: "❌ Échec de l'envoi de l'email de demande de congé",
};
